// MUI
import Box from '@mui/material/Box'

// Custom
import HeroSection from './sections/HeroSection'
import WhyRetrofitSection from './sections/WhyRetrofitSection'
import MachinesSection from './sections/MachinesSection'
import ConnectivitySection from './sections/ConnectivitySection'
import ModernizationSection from './sections/ModernizationSection'
import OutcomesSection from './sections/OutcomesSection'
import ProcessSection from './sections/ProcessSection'
import ScenariosSection from './sections/ScenariosSection'
import CtaSection from './sections/CtaSection'

// Style
import themeColors from 'assets/theme/colors'

export default function TestEquipmentModernizationView() {
  // *** MAIN RENDER ***
  return (
    <Box sx={{ background: themeColors.kroemtech.background }}>
      {/* The hero is full bleed and carries the breadcrumbs itself, so it also
          owns the padding that clears the fixed header. */}
      <HeroSection />

      <WhyRetrofitSection />
      <MachinesSection />
      <ScenariosSection />
      <ConnectivitySection />
      <ModernizationSection />
      <OutcomesSection />
      <ProcessSection />
      <CtaSection />
    </Box>
  )
}
